export default "__VITE_ASSET__Rd7DaCip__"